<template>
  <div class="infoArea">
    <div
      v-if="'supplierName' in displayData"
      class="mb-1 font-weight-bold nameContent"
    >
      {{ displayData.supplierName }}
    </div>
    <div v-if="'name' in displayData" class="mb-3 font-weight-bold nameContent">
      {{ displayData.name ? displayData.name + $t('sale.sale_mr') : '' }}
    </div>
    <div v-if="'nameNormal' in displayData">
      {{
        displayData.nameNormal
          ? displayData.nameNormal + $t('sale.sale_mr')
          : ''
      }}
    </div>

    <div v-if="'postalCode' in displayData">
      {{ displayData.postalCode ? '〒' + displayData.postalCode : '' }}
    </div>
    <div>{{ displayData.address }}</div>
    <div v-if="'place' in displayData">
      {{ displayData.place }}
    </div>
    <div>
      {{
        displayData.phone
          ? (isMaster ? 'TEL' : $t('common.input_phone-number')) +
            '： ' +
            displayData.phone
          : ''
      }}
    </div>
    <div v-if="'fax' in displayData">
      {{
        displayData.fax
          ? $t('common.input_fax-number') + '：' + displayData.fax
          : ''
      }}
    </div>
  </div>
</template>

<script>
export default {
  components: {
    //
  },
  props: {
    displayData: {
      type: Object,
      require: true,
      default: () => {}
      // {
      //   title:'string',
      //   name:'string',
      //   postalCode:'string',
      //   address:'string',
      //   phone:'string',
      // }
    },
    isMaster: { default: false }
  }
}
</script>

<style scoped lang="scss">
.nameContent {
  font-size: 14px;
}

.infoArea > div {
  min-height: 18px;
}
</style>
